import { atom } from "jotai";

/** The sorted slot IDs currently known to be locked; null during a replacement. */
export const confirmedSlotLockKeyAtom = atom<string | null>(null);
